import React from 'react';
import InputBase from '@material-ui/core/InputBase';
import { useStyles } from './FiltersState.styles';
import CloseIcon from '@material-ui/icons/Close';
import FilterStateGroup, { LabelWithValue } from '../../models/filterStateGroup.types';
import { IconButton } from '@material-ui/core';

interface FiltersStateProps<T> {
  filterState: FilterStateGroup<T>[];
  handleUncheckAllFilters: () => void | undefined;
  handleCloseFilterItem: (label?: string, propertyName?: keyof T, dataItem?: LabelWithValue) => void | undefined;
  isOpen: boolean;
  noSpan?: boolean;
  tabIndex?: number;
}

interface FilterSummaryProps<T> {
  filterState: FilterStateGroup<T>[];
  handleUncheckAllFilters: () => void | undefined;
  handleCloseFilterItem: (label?: string, propertyName?: keyof T, dataItem?: LabelWithValue) => void | undefined;
  groupClassName: string;
  filterBarClassName: string;
  inputBaseMargin?: string;
  inputBaseWidth: string;
  tabIndex?: number;
}

const FilterSummary = <T,>(props: FilterSummaryProps<T>) => {
  const classes = useStyles();
  return (
    <>
      {props.filterState.map((group) => (
        <React.Fragment key={group.name}>
          <div className={props.groupClassName}>{group.checkedItems.length > 0 ? group.name : ''}</div>
          {group.checkedItems.map((item) => {
            const label = typeof item === 'string' ? item : item.label;
            const dataItem = typeof item === 'string' ? undefined : item;
            return (
              <React.Fragment key={label}>
                <div className={props.filterBarClassName} style={{ width: label.length * 6 + 32 }}>
                  <InputBase
                    style={{
                      margin: props.inputBaseMargin,
                      width: props.inputBaseWidth,
                      fontSize: '12px',
                      color: 'rgba(44, 45, 62, 0.8)',
                    }}
                    readOnly
                    value={label.trim()}
                    inputProps={{ 'aria-label': 'Szukaj', 'tab-index': props.tabIndex }}
                  />
                  <IconButton
                    disableRipple
                    onClick={() => props.handleCloseFilterItem(label, group.propertyName, dataItem)}
                    style={{ padding: '3px' }}
                  >
                    <CloseIcon
                      onKeyPress={(event: React.KeyboardEvent) => {
                        if (event.key === 'Enter') {
                          props.handleCloseFilterItem(label, group.propertyName, dataItem);
                        }
                      }}
                      className={classes.searchCloseIcon}
                      tabIndex={0}
                      aria-label="Zamknij filtr"
                    />
                  </IconButton>
                </div>
              </React.Fragment>
            );
          })}
        </React.Fragment>
      ))}
      <a
        tabIndex={0}
        onClick={() => {
          props.handleUncheckAllFilters();
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            props.handleUncheckAllFilters();
          }
        }}
        className={classes.filtersSummaryAllClear}
      >
        Wyczyść wszystkie filtry
      </a>
    </>
  );
};

const FiltersState = <FilterStateType,>(props: FiltersStateProps<FilterStateType>) => {
  const classes = useStyles();

  return (
    <>
      {!props.noSpan ? (
        props.isOpen && (
          <div className={classes.filtersSummary} style={{ padding: '0px' }}>
            <FilterSummary
              filterState={props.filterState}
              handleCloseFilterItem={props.handleCloseFilterItem}
              handleUncheckAllFilters={props.handleUncheckAllFilters}
              groupClassName={classes.fitlersSummaryText}
              filterBarClassName={classes.filterbar}
              inputBaseWidth="85%"
              tabIndex={props.tabIndex}
            />
          </div>
        )
      ) : (
        <div className={classes.filtersSummaryNoSpan}>
          <div className={classes.containerNoSpan}>
            <FilterSummary
              filterState={props.filterState}
              handleCloseFilterItem={props.handleCloseFilterItem}
              handleUncheckAllFilters={props.handleUncheckAllFilters}
              groupClassName={classes.fitlersSummaryTextNoSpan}
              filterBarClassName={classes.filterbarNoSpan}
              inputBaseMargin="0 -4px 0 4px"
              inputBaseWidth="100%"
              tabIndex={props.tabIndex}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default FiltersState;
